// extracted by mini-css-extract-plugin
export var currentStep = "_g2-2";
export var nodeCard = "_g2-0";
export var pathHighlighted = "_g2-1";